import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { SelectQuestionPage } from '../select-question/select-question';
import { QuizResultPage } from '../quiz-result/quiz-result';



/**
 * Generated class for the ResponseResultPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@IonicPage()
@Component({
  selector: 'page-response-result',
  templateUrl: 'response-result.html',
})
export class ResponseResultPage {
  opponentsName: string;
  isMyAnswerValid: boolean;
  validCard: any;
  isOpponentsAnswerValid: boolean;
  scoreBoard: any;
  cards: any;
  category: string;
  dataProvider: any;
  questionsCount: number;
  callToActionBtnText: string;
  constructor(public navCtrl: NavController, public navParams: NavParams) {
    this.opponentsName = navParams.get('opponentsName');
    this.isMyAnswerValid = navParams.get('isMyAnswerValid');
    this.validCard = navParams.get('validCard');
    this.isOpponentsAnswerValid = navParams.get('isOpponentsAnswerValid');
    this.scoreBoard = navParams.get('scoreBoard');
    this.cards = navParams.get('cards');
    this.category = navParams.get('category');
    this.dataProvider = navParams.get('dataProvider');
    this.questionsCount = navParams.get('questionsCount');
    if (this.questionsCount < 5) {
      this.callToActionBtnText = 'Continue';
    } else {
      this.callToActionBtnText = 'See Results'
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ResponseResultPage');
  }

  continueQuiz() {
    if (this.questionsCount < 5) {
      this.navCtrl.setRoot(SelectQuestionPage, {cards: this.cards, category: this.category, dataProvider: this.dataProvider});
    } else {
        var result = '';
        if (this.scoreBoard[0].points === this.scoreBoard[1].points) {
            result = 'It\'s a Tie';
        } else if (this.scoreBoard[0].points > this.scoreBoard[1].points) {
            result = this.scoreBoard[0].name  + ' Won';
        } else {
            result = this.scoreBoard[1].name  + ' Won';
        }
        this.navCtrl.setRoot(QuizResultPage, {result, scoreBoard: this.scoreBoard});
    }
  }

  public initQuizResult() {

  }

}



// WEBPACK FOOTER //
// ./src/pages/response-result/response-result.ts